module.exports = __webpack_public_path__ + "assets/media/day11.ec498f68.mp3";